import { z } from 'zod'

export const TenantStoreDomainDTO = z.object({
  domain: z.string().nullable().optional(),
  domain_editable: z.boolean().optional()
})

export type TenantStoreDomainDTO = z.infer<typeof TenantStoreDomainDTO>

export interface TenantStoreDomain {
  domain: string | null
  domainEditable: boolean
}

export function mapDTOToTenantStoreDomain (dto: TenantStoreDomainDTO): TenantStoreDomain {
  return {
    domain: dto.domain ?? null,
    domainEditable: dto.domain_editable ?? false
  }
}
